import React, { useCallback, useState } from 'react'
import { FormGroup, Input, Label } from 'reactstrap'
import Resx from '@/components/Resx'
import * as PropTypes from 'prop-types'

function NationalIdFormatInput (props) {
  const [value, setValue] = useState(props.value || '')

  const handleChange = useCallback((e) => {
    setValue(e.target.value)
    props.onChange(e.target.value)
  }, [props])

  return (
    <FormGroup>
      <Label><Resx name='CodeLists.NationalCodeFormat' />:</Label>
      <Input defaultValue={value} onChange={handleChange} />
    </FormGroup>
  )
}

NationalIdFormatInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
}

export default NationalIdFormatInput



// WEBPACK FOOTER //
// ./src/components/codeLists/nationalIdFormatInput.js